import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled_controls", "expanded", "id", "occurrence", "display"];
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'foundations-theming/utils';
import withTheme from 'ContentComponents/components/cmv2/decorators/withTheme';
import getLang from 'I18n/utils/getLang';
import { userInfoSync } from 'hub-http/userInfo';
import { pick, findWhere, isEqual, isObject } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Link } from 'foundations-components/transitional/components/Link';
import EditFormBreadcrumbs from 'ContentComponents/components/cmv2/EditFormBreadcrumbs';
import FieldGroup from 'ContentComponents/components/cmv2/fields/FieldGroup';
import OccurrencesTable from 'ContentComponents/components/cmv2/occurrences/OccurrencesTable';
import FieldKeyLabel from 'ContentComponents/components/cmv2/FieldKeyLabel';
import EditFormHeader from './EditFormHeader';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import EditFormField from 'ContentComponents/components/cmv2/EditFormField';
import DataTokenProvider from './components/DataTokenProvider';
import OccurrencePrevNextButtons from './occurrences/OccurrencePrevNextButtons';
import { getModuleSchemaValues } from 'ContentUtils/helpers/GraphqlHelpers';
import { CONTENT, STYLE, EDIT, DATA } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { DISPLAY_OPTIONS, FIELD_DISPLAY_WIDTHS, RESOURCES_TO_FETCH_BY_TYPE, SUPPORTED_DATA_TOKEN_FIELDS } from 'ContentComponents/components/cmv2/constants';
import { getAvailableModuleTabs, getBackLinkKey, getDataFields, getFieldFromKey, getFieldGroupForTab, getFilteredFields, getModuleSlideInState, hydrateFields, setFieldSpecificProps, getFieldKeyToSet, getAccordionFieldKeyToOpen, getInheritingFieldsMap, resolveFieldValue } from 'ContentComponents/components/cmv2/utils';
import { isFieldDisabled, areFieldsLocked } from 'ContentComponents/components/cmv2/utils/visibility';
import { defaultValueIsOccurrenceArray, isOccurrenceOrChildOfOccurrenceKey } from 'ContentComponents/components/cmv2/utils/occurrence';
import { buildGroupValue, getGroupValue, getGroupValueFromKey } from 'ContentComponents/components/cmv2/utils/fieldGroup';
import { doFieldsContainExternalInheritance } from 'ContentComponents/components/cmv2/utils/inheritance';
import { buildCollectionMap, scanFieldTree } from 'ContentComponents/components/cmv2/utils/bindingResolution';
import { scrollFieldIntoView } from 'ContentComponents/components/cmv2/utils/scroll';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
import Categories from 'ContentUtils/constants/Categories';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { getThemeSettingsFetchStatus } from 'ContentData/selectors/themeSettings';
import * as ThemeSettingActions from 'ContentData/actions/ThemeSettings';
import { getGlobalStylesFields, getGlobalStylesOverrides, getGlobalStylesFetchStatus } from 'ContentData/selectors/globalStyles';
import * as GlobalStylesActions from 'ContentData/actions/GlobalStyles';
import { getDeepValue, isNullOrUndefined, mergeDeep, removeDeepValue, setDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import * as ModuleContentTypes from 'ContentUtils/constants/ModuleContentTypes';
import * as BrandingActions from 'ContentData/actions/Branding';
import * as GraphqlActions from 'ContentData/actions/Graphql';
import * as RequestStatuses from 'ContentUtils/constants/RequestStatus';
import { getBrandSettingsFetchStatus, getBusinessUnitId, getContentCategoryName } from 'ContentData/selectors/branding';
import { getDataQueryVariablesByPath } from 'ContentData/selectors/dataqueries';
import { getInheritanceData } from 'ContentData/selectors/inheritance';
import { getTranslatedModuleInlineHelpText } from 'ContentUtils/helpers/TranslationsHelpers';
import { bindingsToFieldConfigs, fieldConfigsToBindings } from 'ContentData/utils/fieldConfig';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { StylesLoader } from './globalStylesPreview/StylesLoader';
import { View } from 'foundations-components/components/View';
import { shouldLoadGlobalStyles } from './utils/globalStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
const TwoColumnsFieldWrapper = styled.div.withConfig({
  displayName: "EditForm__TwoColumnsFieldWrapper"
})(["vertical-align:top;display:inline-block;width:50%;"]);
const SlideInAnimationWrapper = styled.div.withConfig({
  displayName: "EditForm__SlideInAnimationWrapper"
})(({
  shouldSlideInFromLeft,
  shouldSlideInFromRight
}) => {
  if (shouldSlideInFromLeft) {
    return `
        @keyframes slideInFromLeft {
          from {
            transform: translate(-100%, 0);
          }
          to {
            transform: translate(0, 0);
          }
        }
        animation: slideInFromLeft 0.5s;
      `;
  } else if (shouldSlideInFromRight) {
    return `
        @keyframes slideInFromRight {
          from {
            transform: translate(100%, 0);
          }
          to {
            transform: translate(0, 0);
          }
        }
        animation: slideInFromRight 0.5s;
      `;
  }
  return '';
});
const DefaultFieldWrapper = ({
  children
}) => {
  return children;
};
let scrollToFieldAfterRemountData = null;
const mapStateToProps = (state, props) => {
  const {
    inheritanceDataOverrides,
    moduleSpec
  } = props;
  return {
    brandSettingsRequestStatus: getBrandSettingsFetchStatus(state),
    businessUnitId: getBusinessUnitId(state, props),
    contentCategoryName: getContentCategoryName(state),
    dataQueryVariableSchema: getDataQueryVariablesByPath(state, {
      dataQueryPath: moduleSpec && moduleSpec.dataQueryAbsolutePath
    }),
    globalStylesFields: getGlobalStylesFields(state),
    globalStylesOverrides: getGlobalStylesOverrides(state),
    globalStylesRequestStatus: getGlobalStylesFetchStatus(state),
    inheritanceData: inheritanceDataOverrides || getInheritanceData(state),
    themeSettingsRequestStatus: getThemeSettingsFetchStatus(state, moduleSpec)
  };
};
const mapDispatchToProps = {
  fetchBranding: BrandingActions.fetchBranding,
  fetchBusinessUnit: BrandingActions.fetchBusinessUnit,
  fetchGlobalStyles: GlobalStylesActions.fetchGlobalStyles,
  fetchThemeSettings: ThemeSettingActions.fetchThemeSettings,
  fetchModuleDataVariables: GraphqlActions.fetchModuleDataVariables
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class EditForm extends Component {
  constructor(props) {
    super(props);
    this.hasCollectionFields = false;
    this.hasGlobalStylesBindings = false;
    this.pendingAutoCorrections = new Map();
    this.isFlushAutoCorrectionsScheduled = false;
    this.isUnmounted = false;
    this.cachedInheritingFieldsUtils = null;
    this.cachedModuleSpecFields = null;
    this.queueAutoCorrection = (fieldKey, value) => {
      const keyString = fieldKey.join('.');
      this.pendingAutoCorrections.set(keyString, {
        fieldKey,
        value
      });
      if (!this.isFlushAutoCorrectionsScheduled) {
        this.isFlushAutoCorrectionsScheduled = true;
        queueMicrotask(() => this.flushAutoCorrections());
      }
    };
    this.reportAutoCorrectionStatus = (fieldKey, isAutoCorrected) => {
      const key = fieldKey.join('.');
      this.setState(prev => {
        const alreadyTracked = (key in prev.autoCorrectedFieldKeys);
        if (isAutoCorrected && alreadyTracked || !isAutoCorrected && !alreadyTracked) return null;
        const _prev$autoCorrectedFi = prev.autoCorrectedFieldKeys,
          rest = _objectWithoutPropertiesLoose(_prev$autoCorrectedFi, [key].map(_toPropertyKey));
        return {
          autoCorrectedFieldKeys: isAutoCorrected ? Object.assign({}, rest, {
            [key]: true
          }) : rest
        };
      });
    };
    this.onBindingChange = (fieldPath, ref) => {
      const {
        onBindingsChange
      } = this.props;
      const bindings = Object.assign({}, this.state.bindings, {
        [fieldPath]: ref
      });
      if (onBindingsChange) {
        onBindingsChange(bindingsToFieldConfigs(bindings));
      }
      this.setState({
        bindings
      });
    };
    this.onDataTokenChange = (fieldKey, value) => {
      const {
        onUpdate,
        module
      } = this.props;
      const newModule = setDeepValue(module, ['dataTokenPaths', fieldKey], value);
      onUpdate(fieldKey, value, newModule);
    };
    this.renderAlert = content => /*#__PURE__*/_jsx(Alert, {
      marginBlock: this.props.flush ? '400' : undefined,
      marginInline: this.props.flush ? '600' : undefined,
      type: "info",
      children: content
    });
    this.onUpdate = this.onUpdate.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onOccurrenceChange = this.onOccurrenceChange.bind(this);
    this.setFieldKey = this.setFieldKey.bind(this);
    this.onFieldGroupOpenChange = this.onFieldGroupOpenChange.bind(this);
    this.onFieldReset = this.onFieldReset.bind(this);
    this.fetchInheritedValues = this.fetchInheritedValues.bind(this);
    this.onAnimationEnd = this.onAnimationEnd.bind(this);
    this.onDataFieldChange = this.onDataFieldChange.bind(this);
    this.onDataTokenChange = this.onDataTokenChange.bind(this);
    this.getFieldsForTab = this.getFieldsForTab.bind(this);
    this.scrollToField = this.scrollToField.bind(this);
    this.getOnFieldChangeHandler = this.getOnFieldChangeHandler.bind(this);
    this.getResourceProps = this.getResourceProps.bind(this);
    this.onDataOccurrenceFieldChange = this.onDataOccurrenceFieldChange.bind(this);
    this.scrollToFieldAfterRemount = this.scrollToFieldAfterRemount.bind(this);
    this.queueAutoCorrection = this.queueAutoCorrection.bind(this);
    this.flushAutoCorrections = this.flushAutoCorrections.bind(this);
    this.resolveFieldValue = this.resolveFieldValue.bind(this);
    this.isInheritedValueSupportEnabled = Routes.isUngated(gate('CMv2:FontFieldInheritedValueSupport')) || Boolean(props.isInGlobalStyles);
    this.applyBindingFieldFlags();
    this.shouldLoadGlobalStyles = Boolean(!props.isInGlobalStyles && shouldLoadGlobalStyles(this.fields));
    this.topLevelNonContentFieldGroupKey = null;
    this.scrollToFieldOnModuleSpecUpdate = true;
    this.moduleTabs = null;
    const collectionMap = this.getCollectionMap(props);
    this.state = {
      autoCorrectedFieldKeys: {},
      bindings: props.bindings ? fieldConfigsToBindings(props.bindings) : {},
      collectionMap,
      fieldKey: props.fieldKey,
      openFieldGroups: {}
    };
  }
  componentDidMount() {
    const {
      onEditFormMounted,
      moduleSpec,
      fetchModuleDataVariables,
      scrollToFieldOnMount
    } = this.props;
    if (onEditFormMounted) onEditFormMounted();
    if (moduleSpec && moduleSpec.dataQueryAbsolutePath) {
      fetchModuleDataVariables(moduleSpec.dataQueryAbsolutePath);
    }
    if (moduleSpec.fields && scrollToFieldOnMount) {
      this.scrollToFieldOnModuleSpecUpdate = false;
      this.scrollToField({
        fieldKey: scrollToFieldOnMount
      });
    }
    this.fetchInheritedValues();
    document.addEventListener('FIELD_REVEAL_LISTENER_READY', this.scrollToFieldAfterRemount);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      businessUnitId: prevBusinessUnitId,
      fieldKey: prevFieldKey,
      tab: prevTab
    } = prevProps;
    const {
      brandSettingsRequestStatus,
      businessUnitId,
      enableSlideInAnimation,
      fetchBranding,
      fieldKey,
      globalStylesFields,
      globalStylesOverrides,
      tab,
      moduleSpec,
      scrollToFieldOnMount
    } = this.props;
    const {
      fieldKey: prevStateFieldKey
    } = prevState;
    const {
      fieldKey: stateFieldKey
    } = this.state;
    if (!isEqual(prevProps.fieldKey, fieldKey)) {
      this.setState({
        fieldKey
      });
    }
    if (enableSlideInAnimation && !isEqual(prevStateFieldKey, stateFieldKey)) {
      this.setState(getModuleSlideInState(prevStateFieldKey, stateFieldKey));
    }
    if (prevTab !== tab) {
      this.setFieldKey(null);
    }
    if (!prevProps.moduleSpec.fields && moduleSpec.fields) {
      this.applyBindingFieldFlags();
      this.fetchInheritedValues();

      // Rebuild collection map now that fields are available — covers the case
      // where GS data was already SUCCEEDED before fields arrived (the
      // GS-prop-change branch below won't fire since the store is unchanged).
      this.setState({
        collectionMap: this.getCollectionMap(this.props)
      });
      if (this.scrollToFieldOnModuleSpecUpdate && scrollToFieldOnMount) {
        this.scrollToField({
          fieldKey: scrollToFieldOnMount
        });
      }
    }

    // Rebuild when GS data in Redux changes reference — the cold-start case
    // (element form fetched on mount and data has just arrived: UNINITIALIZED
    // → SUCCEEDED) and any subsequent live updates to the cached GS data.
    if (this.hasGlobalStylesBindings && (prevProps.globalStylesFields !== globalStylesFields || prevProps.globalStylesOverrides !== globalStylesOverrides)) {
      this.setState({
        collectionMap: this.getCollectionMap(this.props)
      });
    }
    if ((tab === DATA || tab === STYLE) && prevFieldKey !== fieldKey && isEqual(fieldKey, this.topLevelNonContentFieldGroupKey)) {
      this.setFieldKey(null);
    }
    if (businessUnitId !== prevBusinessUnitId && brandSettingsRequestStatus === RequestStatuses.UNINITIALIZED && moduleSpec.fields && doFieldsContainExternalInheritance(moduleSpec.fields)) {
      fetchBranding(businessUnitId);
    }
  }
  componentWillUnmount() {
    this.isUnmounted = true;
    document.removeEventListener('FIELD_REVEAL_LISTENER_READY', this.scrollToFieldAfterRemount);
  }
  get isInDataTab() {
    return this.props.tab === DATA;
  }
  get fields() {
    return hydrateFields(this.props);
  }
  get scopes() {
    const {
      scopes
    } = this.props.auth;
    if (scopes) return scopes;
    try {
      const {
        user
      } = userInfoSync();
      return user.scopes;
    } catch (error) {
      return [];
    }
  }
  get moduleData() {
    const {
      breakpoint,
      breakpointStyles = {},
      module
    } = this.props;
    if (this.isInDataTab) {
      return module.dataQueryVariables;
    }
    if (breakpoint) {
      const styles = breakpointStyles[breakpoint] || {};
      return styles.fieldStyles || {};
    }
    return module;
  }
  applyBindingFieldFlags() {
    const {
      hasCollection,
      hasGlobalStylesBindings
    } = scanFieldTree(this.fields);
    this.hasCollectionFields = hasCollection;
    this.hasGlobalStylesBindings = hasGlobalStylesBindings;
  }

  // Element forms with `binding: { context: 'global_styles' }` consume theme
  // colors fetched into Redux — their own fields carry no `collection` source
  // markers, so the map must be built from the fetched GS data. The GS theme
  // plugin is the inverse: its own fields *are* the source.
  getCollectionMap(props) {
    if (!props.isInGlobalStyles && this.hasGlobalStylesBindings && props.globalStylesRequestStatus === RequestStatuses.SUCCEEDED) {
      var _props$globalStylesFi;
      return buildCollectionMap((_props$globalStylesFi = props.globalStylesFields) !== null && _props$globalStylesFi !== void 0 ? _props$globalStylesFi : [], props.globalStylesOverrides);
    }
    return buildCollectionMap(this.fields, props.module);
  }
  rebuildCollectionMap(newModule) {
    if (this.hasCollectionFields) {
      const collectionMap = buildCollectionMap(this.fields, newModule);
      this.setState({
        collectionMap
      });
    }
  }
  get isLocked() {
    const {
      fields
    } = this;
    const {
      hideLockedFields,
      overrideable,
      tab
    } = this.props;
    const locked = hideLockedFields && areFieldsLocked(fields);
    return tab === CONTENT && (!overrideable || locked);
  }
  isFieldAutoCorrected(field, key, isDefaultValue) {
    const keys = this.state.autoCorrectedFieldKeys;
    return this.isInheritedValueSupportEnabled && !isDefaultValue && !!field.inherited_value && Object.keys(keys).length > 0 && keys[key.join('.')] === true;
  }

  // Provides field inheritance utils to child fields, cached per moduleSpec.fields
  getInheritingFieldsUtils() {
    const moduleSpecFields = this.props.moduleSpec.fields;
    if (this.cachedModuleSpecFields === moduleSpecFields && this.cachedInheritingFieldsUtils) {
      return this.cachedInheritingFieldsUtils;
    }
    this.cachedModuleSpecFields = moduleSpecFields || null;
    this.cachedInheritingFieldsUtils = {
      map: getInheritingFieldsMap(this.fields),
      getFieldValue: this.resolveFieldValue,
      queueCorrection: this.queueAutoCorrection,
      reportAutoCorrectionStatus: this.reportAutoCorrectionStatus
    };
    return this.cachedInheritingFieldsUtils;
  }
  resolveFieldValue(fieldKey, field, groupValue) {
    return resolveFieldValue({
      moduleData: this.moduleData,
      fields: this.fields,
      fieldKey,
      field,
      groupValue
    });
  }
  scrollToFieldAfterRemount() {
    if (scrollToFieldAfterRemountData) {
      this.scrollToField(Object.assign({}, scrollToFieldAfterRemountData, {
        afterRemount: false
      }));
      scrollToFieldAfterRemountData = null;
    }
  }
  getDataTokenAuthValues(fieldType) {
    const {
      scopes,
      gates
    } = this.props.auth;
    const defaultValue = {
      scopes: [],
      gates: []
    };
    if (!SUPPORTED_DATA_TOKEN_FIELDS[fieldType]) {
      return defaultValue;
    }
    if (scopes && gates) return {
      scopes,
      gates
    };
    try {
      const {
        user
      } = userInfoSync();
      return {
        scopes: user.scopes
      };
    } catch (error) {
      return defaultValue;
    }
  }
  fetchInheritedValues() {
    const {
      businessUnitId,
      contentId,
      parentConnectionContentId,
      contentCategoryName,
      fetchBranding,
      fetchBusinessUnit,
      fetchGlobalStyles,
      fetchThemeSettings,
      brandSettingsRequestStatus,
      globalStylesRequestStatus,
      isInGlobalStyles,
      isInNewEditor,
      themeSettingsRequestStatus,
      moduleSpec
    } = this.props;
    const brandingContentId = parentConnectionContentId || contentId;
    if (moduleSpec.fields && doFieldsContainExternalInheritance(moduleSpec.fields)) {
      if (brandSettingsRequestStatus === RequestStatuses.UNINITIALIZED) {
        if (isNullOrUndefined(businessUnitId) && contentCategoryName && brandingContentId) {
          fetchBusinessUnit(contentCategoryName, brandingContentId);
        } else {
          fetchBranding(businessUnitId);
        }
      }
      if ((moduleSpec.isThemeAsset || moduleSpec.path && doFieldsContainExternalInheritance(moduleSpec.fields)) && themeSettingsRequestStatus === RequestStatuses.UNINITIALIZED) {
        fetchThemeSettings(moduleSpec.path);
      }
    }
    if (isInNewEditor && !isInGlobalStyles && this.hasGlobalStylesBindings && globalStylesRequestStatus === RequestStatuses.UNINITIALIZED) {
      fetchGlobalStyles({
        bufferTheme: true
      });
    }
  }
  onUpdate(key, value, module, isDeletedField = false, options) {
    const {
      moduleSpec,
      onUpdate
    } = this.props;
    const topLevelFieldNames = moduleSpec.fields.map(_field => _field.name);
    if (isDeletedField) {
      topLevelFieldNames.push(key[0]);
    }
    const pickedModule = pick(module, topLevelFieldNames);
    if (options) {
      onUpdate(key, value, pickedModule, options);
    } else {
      onUpdate(key, value, pickedModule);
    }
  }
  onFieldChange(key, value, isDeletedField) {
    const newModule = setDeepValue(this.moduleData, key, value);
    this.onUpdate(key, value, newModule, isDeletedField);
    this.rebuildCollectionMap(newModule);
    const {
      autoCorrectedFieldKeys
    } = this.state;
    if (this.isInheritedValueSupportEnabled && Object.keys(autoCorrectedFieldKeys).length > 0) {
      const keyStr = key.join('.');
      if (keyStr in autoCorrectedFieldKeys) {
        const rest = _objectWithoutPropertiesLoose(autoCorrectedFieldKeys, [keyStr].map(_toPropertyKey));
        this.setState({
          autoCorrectedFieldKeys: rest
        });
      }
    }
  }

  // Auto-correction flow: child fields queue corrections via queueCorrection,
  // batched and applied in flushAutoCorrections. Both flushAutoCorrections (live edits)
  // and reportAutoCorrectionStatus (rehydration on mount) track corrected fields in
  // autoCorrectedFieldKeys so the UI treats them as resettable.
  flushAutoCorrections() {
    this.isFlushAutoCorrectionsScheduled = false;
    if (this.isUnmounted || this.pendingAutoCorrections.size === 0) {
      return;
    }
    const corrections = Array.from(this.pendingAutoCorrections.values());
    this.pendingAutoCorrections.clear();
    const newKeys = {};
    for (const {
      fieldKey,
      value
    } of corrections) {
      const existing = getDeepValue(this.moduleData, fieldKey);
      const merged = isObject(existing) ? Object.assign({}, existing, value) : value;
      const newModule = setDeepValue(this.moduleData, fieldKey, merged);
      this.onUpdate(fieldKey, merged, newModule, false, {
        isAutoCorrection: true
      });
      newKeys[fieldKey.join('.')] = true;
    }
    this.setState(prev => ({
      autoCorrectedFieldKeys: Object.assign({}, prev.autoCorrectedFieldKeys, newKeys)
    }));
  }
  onDataFieldChange(key, value) {
    const {
      onUpdate,
      module,
      dataQueryVariableSchema
    } = this.props;
    const dataValues = getModuleSchemaValues(dataQueryVariableSchema, module.dataQueryVariables);
    dataValues[key] = value;
    const newModule = setDeepValue(module, ['dataQueryVariables'], dataValues);
    onUpdate(key, value, newModule);
  }
  onDataOccurrenceFieldChange(key, value) {
    const {
      onUpdate,
      module,
      dataQueryVariableSchema
    } = this.props;
    const dataValues = getModuleSchemaValues(dataQueryVariableSchema, module.dataQueryVariables);
    const updatedValues = setDeepValue(dataValues, key, value);
    const newModule = setDeepValue(module, ['dataQueryVariables'], updatedValues);
    onUpdate(key, value, newModule);
  }
  onFieldReset(key) {
    const {
      module,
      onFieldReset
    } = this.props;
    const newModule = removeDeepValue(module, key);
    if (onFieldReset) {
      onFieldReset(key, newModule);
    } else {
      this.onUpdate(key, undefined, newModule);
    }
    this.rebuildCollectionMap(newModule);
  }
  onOccurrenceChange(key, value) {
    const topLevelField = this.fields.find(_field => _field.name === key[0]);
    const {
      default: topLevelDefault,
      name
    } = topLevelField;
    const {
      fields,
      moduleData
    } = this;
    let newModule;
    if (getDeepValue(moduleData, key) === undefined) {
      if (Routes.isUngated('Cms:FixDefaultValuesInGroups')) {
        const groupValue = getGroupValue(fields, key, moduleData, {
          maintainOccurrenceArrays: true
        });
        if (groupValue) {
          newModule = mergeDeep(groupValue, moduleData);
        }
      }
      if (!newModule && topLevelDefault) {
        const topLevelDefaultValue = {
          [name]: topLevelDefault
        };
        newModule = mergeDeep(topLevelDefaultValue, moduleData);
      }
    }
    if (newModule) {
      newModule = setDeepValue(newModule, key, value);
      this.onUpdate(key, value, newModule);
    } else {
      this.onFieldChange(key, value);
    }
  }
  getModuleTabs() {
    const {
      moduleTabs,
      props,
      scopes
    } = this;
    if (!moduleTabs) this.moduleTabs = getAvailableModuleTabs(props, scopes);
    return this.moduleTabs;
  }
  onFieldGroupOpenChange(open, fieldKey) {
    const {
      openFieldGroups
    } = this.state;
    this.setState({
      openFieldGroups: Object.assign({}, openFieldGroups, {
        [fieldKey]: open
      })
    });
  }
  setFieldKey(fieldKey) {
    const {
      onFieldKeyChange
    } = this.props;
    if (onFieldKeyChange) {
      onFieldKeyChange(fieldKey);
    } else {
      this.setState({
        fieldKey
      });
    }
  }
  getFieldsForTab(tabGroup) {
    const {
      dataQueryVariableSchema,
      module,
      tab
    } = this.props;
    if (tab === CONTENT || !tab) {
      return getFilteredFields(this.fields, this.props, this.scopes);
    }
    if (tab === DATA) {
      return getDataFields(module, dataQueryVariableSchema);
    }
    if (tabGroup) {
      return getFilteredFields(tabGroup.children, this.props, this.scopes, {
        isExternalTabGroup: true
      });
    }
    return [];
  }
  scrollToField({
    fieldKey,
    section,
    dispatchEvent = false,
    afterRemount = false
  }) {
    if (afterRemount) {
      scrollToFieldAfterRemountData = {
        fieldKey,
        section,
        dispatchEvent
      };
      return;
    }
    const _scrollFieldIntoView = () => {
      if (dispatchEvent) {
        const event = new CustomEvent('FIELD_REVEAL', {
          detail: {
            fieldKey,
            section
          }
        });
        document.dispatchEvent(event);
      } else {
        scrollFieldIntoView(fieldKey, section, this.props.theme);
      }
    };
    const fieldKeyToSet = getFieldKeyToSet(fieldKey, this.fields);
    const {
      fieldKey: currentFieldKey
    } = this.state;
    const maybeOpenAccordionAndScrollFieldIntoView = () => {
      const accordionKey = getAccordionFieldKeyToOpen(fieldKey, this.fields);
      if (accordionKey && accordionKey.length) {
        this.onFieldGroupOpenChange(true, accordionKey.join('.'));
        setTimeout(() => {
          _scrollFieldIntoView();
        }, 250);
      } else {
        _scrollFieldIntoView();
      }
    };
    if (!isEqual(currentFieldKey, fieldKeyToSet)) {
      this.setFieldKey(fieldKeyToSet);
      setTimeout(() => {
        maybeOpenAccordionAndScrollFieldIntoView();
      }, 500);
    } else {
      maybeOpenAccordionAndScrollFieldIntoView();
    }
  }
  onAnimationEnd() {
    this.setState({
      shouldSlideInFromRight: false,
      shouldSlideInFromLeft: false
    });
  }
  getResourceProps(type) {
    const {
      domain,
      salesforceIntegrationStatus
    } = this.props;
    return {
      domain: type === FieldTypes.LOGO && domain,
      options: this.props[RESOURCES_TO_FETCH_BY_TYPE[type]],
      salesforceIntegrationStatus: type === FieldTypes.SFDC_CAMPAIGN ? salesforceIntegrationStatus : []
    };
  }
  getOnFieldChangeHandler(fieldId) {
    if (fieldId && isOccurrenceOrChildOfOccurrenceKey(this.state.fieldKey)) {
      if (this.isInDataTab) return this.onDataOccurrenceFieldChange;
      return this.onOccurrenceChange;
    } else if (this.isInDataTab) {
      return this.onDataFieldChange;
    } else {
      return this.onFieldChange;
    }
  }
  renderOccurrence(field, key, onFieldChange, options = {}) {
    const {
      allowFieldReset,
      breakpoint,
      breakpointStyles,
      flush,
      hideRichTextInFloatingPanel,
      LabelComponent,
      module,
      moduleSpec,
      readOnly
    } = this.props;
    const {
      groupValue,
      parentFieldGroupDisabled
    } = options;
    const {
      group_occurrence_meta,
      type
    } = field;
    const {
      fields,
      moduleData,
      scopes
    } = this;
    const {
      featured_enabled,
      featured_limit
    } = group_occurrence_meta || {};
    const isFieldGroup = type === FieldTypes.GROUP;
    const resources = pick(this.props, Object.values(RESOURCES_TO_FETCH_BY_TYPE || {}));
    const disabled = parentFieldGroupDisabled || isFieldDisabled({
      allFields: fields,
      breakpoint,
      breakpointStyles,
      field,
      module,
      scopes
    });
    let values = getDeepValue(moduleData, key);
    const isDefaultValue = values === undefined || !defaultValueIsOccurrenceArray(field) && values && !values.length;
    if (values === undefined && !isNullOrUndefined(groupValue)) {
      values = getGroupValueFromKey(groupValue, key);
    }
    if (values === undefined && defaultValueIsOccurrenceArray(field)) {
      values = field.default;
    }
    if (isNullOrUndefined(values) || !Array.isArray(values)) {
      values = [];
    }
    return /*#__PURE__*/_jsx(OccurrencesTable, {
      disabled: disabled,
      featuredEnabled: isFieldGroup && featured_enabled,
      featuredLimit: featured_limit,
      field: field,
      fieldKey: key,
      flush: flush,
      hideRichTextInFloatingPanel: hideRichTextInFloatingPanel,
      isDefaultValue: isDefaultValue,
      onFieldReset: this.onFieldReset,
      LabelComponent: LabelComponent,
      allowFieldReset: allowFieldReset,
      onFieldChange: onFieldChange,
      path: moduleSpec.path,
      scrollToField: this.scrollToField,
      setFieldKey: this.setFieldKey,
      readOnly: readOnly,
      resources: resources,
      values: values
    }, `field_${key}`);
  }
  renderFieldGroup(field, key, options = {}) {
    const {
      allowFieldReset,
      breakpoint,
      breakpointStyles,
      componentsByType,
      GroupLabelChild,
      isInGlobalStyles,
      isInNewEditor,
      LabelComponent,
      lazyRenderGroups,
      module,
      useOnDark
    } = this.props;
    const {
        children,
        disabled_controls,
        expanded,
        id,
        occurrence,
        display
      } = field,
      rest = _objectWithoutPropertiesLoose(field, _excluded);
    const {
      message
    } = disabled_controls || {};
    const {
      fieldKey,
      openFieldGroups,
      autoCorrectedFieldKeys
    } = this.state;
    const {
      currentFieldId,
      parentFieldGroupDisabled
    } = options;
    const {
      GROUP
    } = FieldTypes;
    const {
      fields,
      moduleData,
      scopes
    } = this;
    const FieldGroupComponent = componentsByType[GROUP] || FieldGroup;
    const fieldGroupSelected = currentFieldId && currentFieldId === id;
    if (!Routes.isUngated('Cms:FixDefaultValuesInGroups') && !options.groupValue && (occurrence || isOccurrenceOrChildOfOccurrenceKey(key)) && fieldGroupSelected) {
      let groupValueData = Object.assign({}, moduleData);
      if (!isNullOrUndefined(field.default)) {
        const topLevelField = fields.find(_field => _field.name === key[0]);
        const topLevelDefaultValue = topLevelField && !isNullOrUndefined(topLevelField.default) ? {
          [topLevelField.name]: topLevelField.default
        } : {};
        groupValueData = mergeDeep(topLevelDefaultValue, groupValueData);
      }
      options = {
        groupValue: buildGroupValue(groupValueData, key),
        currentFieldId
      };
    }
    const disabled = parentFieldGroupDisabled || isFieldDisabled({
      allFields: fields,
      breakpoint,
      breakpointStyles,
      field,
      groupOccurrenceOptions: options,
      module,
      scopes
    });
    const containsNestedGroups = !!findWhere(children, {
      type: GROUP
    });
    const childrenAreVisible = display ? display !== DISPLAY_OPTIONS.DRILLDOWN : !containsNestedGroups;

    // Only filter and render a group's children if the children are immediately visible.
    // This means the children of drilldown groups aren't rendered until needed.
    let renderedChildren = null;
    if (!lazyRenderGroups || childrenAreVisible || key === fieldKey) {
      let filteredFields = getFilteredFields(children, this.props, scopes, Object.assign({}, options, {
        isExternalTabGroup: true
      }));
      if (!filteredFields.length) return null;

      // When parent group has tabs display, render child groups inline without labels
      if (display === DISPLAY_OPTIONS.TABS) {
        filteredFields = filteredFields.map(childField => {
          if (childField.type === GROUP && !childField.display) {
            return Object.assign({}, childField, {
              display: DISPLAY_OPTIONS.INLINE,
              hideLabel: true
            });
          }
          return Object.assign({}, childField, {
            hideLabel: true
          });
        });
      }
      renderedChildren = this.renderFormFields(filteredFields, key, Object.assign({}, options, {
        inExpandableFieldGroup: !fieldGroupSelected,
        parentFieldGroupDisabled: disabled
      }));
    }
    if (fieldGroupSelected) {
      const disabledAlert = disabled && message && /*#__PURE__*/_jsx(Alert, {
        type: "tip",
        marginInline: "600",
        marginBlock: "300",
        children: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: message,
          useStrict: true
        })
      });
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [disabledAlert, renderedChildren]
      });
    }
    const fieldGroupOpen = openFieldGroups[key.join('.')];
    const isDefaultValue = getDeepValue(moduleData, key) === undefined;
    const isGroupAutoCorrected = this.isInheritedValueSupportEnabled && Object.keys(autoCorrectedFieldKeys).length > 0 && (children || []).some(child => this.isFieldAutoCorrected(child, [...key, child.name], false));
    return /*#__PURE__*/_createElement(FieldGroupComponent, Object.assign({}, rest, {
      allowFieldReset: allowFieldReset,
      key: `field_${key}`,
      childFields: children,
      containsNestedGroups: containsNestedGroups,
      disabled: disabled,
      display: display,
      disabledMessage: message,
      firstChildIsGroup: children && children.length && children[0].type === FieldTypes.GROUP,
      fieldGroupOpen: !isNullOrUndefined(fieldGroupOpen) ? fieldGroupOpen : expanded,
      fieldKey: key,
      GroupLabelChild: GroupLabelChild,
      isDefaultValue: isDefaultValue || isGroupAutoCorrected,
      isInNewEditor: Boolean(isInNewEditor || isInGlobalStyles),
      LabelComponent: LabelComponent,
      onFieldReset: this.onFieldReset,
      onFieldGroupOpenChange: this.onFieldGroupOpenChange,
      onFieldUnlink: () => {
        this.onFieldChange(key, rest.default);
      },
      onEditGroupClick: () => this.setFieldKey(key),
      scrollToField: this.scrollToField,
      useOnDark: useOnDark
    }), renderedChildren);
  }
  renderField(field, key, onFieldChange, options = {}) {
    const {
      allowFieldReset,
      breakpoint,
      breakpointStyles,
      componentsByType,
      contentAssistanceEnabled,
      contentCategoryId,
      editor,
      flush,
      globalStylesRequestStatus,
      highlightedField,
      isInGlobalStyles,
      isInNewEditor,
      isPublicContent,
      LabelComponent,
      module,
      moduleSpec,
      onRedirect,
      readOnly,
      trackFieldAction,
      uploadedFileAccess,
      useOnDark,
      validateOnMount,
      handleFieldEditLinkOverride
    } = this.props;
    const {
      bindings,
      collectionMap
    } = this.state;
    const {
      inExpandableFieldGroup = false,
      parentFieldGroupDisabled
    } = options;
    const {
      gates,
      scopes: dataTokenScopes
    } = this.getDataTokenAuthValues(field.type);
    const {
      fields,
      moduleData,
      scopes
    } = this;
    const disabled = parentFieldGroupDisabled || isFieldDisabled({
      allFields: fields,
      breakpoint,
      breakpointStyles,
      field,
      module,
      scopes
    });
    const {
      contentTypes = [],
      hostTemplateTypes = [],
      path
    } = moduleSpec;
    const isEmailOrAnyType = !!contentTypes && (contentTypes.indexOf(ModuleContentTypes.ANY) > -1 || contentTypes.indexOf(ModuleContentTypes.EMAIL) > -1);
    const moduleDataValue = getDeepValue(moduleData, key);
    const isDefaultValue = moduleDataValue === undefined || isNullOrUndefined(field.default) && (moduleDataValue === '' || moduleDataValue === null);
    const isAutoCorrected = this.isFieldAutoCorrected(field, key, isDefaultValue);
    const value = this.resolveFieldValue(key, field, options.groupValue);
    const isGlobalStylesLoading = Boolean(isInNewEditor) && !isInGlobalStyles && this.hasGlobalStylesBindings && globalStylesRequestStatus !== RequestStatuses.SUCCEEDED && globalStylesRequestStatus !== RequestStatuses.FAILED;
    return /*#__PURE__*/_jsx(EditFormField, {
      bindingContext: {
        bindings,
        collectionMap,
        isGlobalStylesLoading,
        onBindingChange: this.onBindingChange
      },
      breakpoint: breakpoint,
      contentAssistanceEnabled: contentAssistanceEnabled,
      contentTypes: contentTypes,
      componentsByType: componentsByType,
      currentFieldKey: this.state.fieldKey,
      disabled: disabled,
      gates: gates,
      scopes: dataTokenScopes,
      editor: editor,
      field: field,
      fieldKey: key,
      flush: flush,
      highlightedField: highlightedField,
      hostTemplateTypes: hostTemplateTypes,
      isEmailOrAnyType: isEmailOrAnyType // is the module email-compatible
      ,
      isInEmail: contentCategoryId === Categories.email.id // is the module in an email
      ,
      isInNewEditor: Boolean(isInNewEditor || isInGlobalStyles),
      isPublicContent: isPublicContent,
      LabelComponent: LabelComponent,
      allowFieldReset: allowFieldReset,
      isDefaultValue: isDefaultValue || isAutoCorrected,
      modulePath: path,
      onDataTokenChange: this.onDataTokenChange,
      onFieldChange: onFieldChange,
      onFieldReset: this.onFieldReset,
      onRedirect: onRedirect,
      inheritingFieldsUtils: this.isInheritedValueSupportEnabled ? this.getInheritingFieldsUtils() : undefined,
      readOnly: readOnly,
      resourceProps: this.getResourceProps(field.type),
      scrollToField: this.scrollToField,
      setFieldKey: this.setFieldKey,
      trackFieldAction: trackFieldAction,
      uniqueKey: this.props.uniqueKey,
      uploadedFileAccess: uploadedFileAccess,
      useOnDark: useOnDark || inExpandableFieldGroup,
      validateOnMount: validateOnMount,
      value: value,
      handleFieldEditLinkOverride: handleFieldEditLinkOverride
    }, `field_${key}`);
  }
  renderFormField(field, key, options = {}) {
    const {
      currentFieldId
    } = options;
    const {
      fields,
      moduleData
    } = this;
    const onFieldChange = this.getOnFieldChangeHandler(currentFieldId);
    field = setFieldSpecificProps(field, Object.assign({}, this.props, {
      onFieldChange: this.onFieldChange,
      scrollToField: this.scrollToField
    }));
    if (Routes.isUngated('Cms:FixDefaultValuesInGroups')) {
      const groupValue = getGroupValue(fields, key, moduleData);
      if (groupValue) options.groupValue = groupValue;
    }
    if (field.occurrence && currentFieldId !== field.id) {
      return this.renderOccurrence(field, key, onFieldChange, options);
    }
    if (field.type === FieldTypes.GROUP) {
      return this.renderFieldGroup(field, key, options);
    }
    return this.renderField(field, key, onFieldChange, options);
  }
  renderFormFields(fields, key, options) {
    const {
      moduleSpec,
      FieldWrapper: _FieldWrapper,
      id,
      tab
    } = this.props;
    const FieldWrapper = _FieldWrapper;
    if (moduleSpec.inline_editable) return null;
    return fields.map(field => {
      const fieldKey = key ? key.concat(field.name) : [field.name];
      const wrappedFormField = /*#__PURE__*/_jsx(FieldWrapper, {
        "data-test-id": "field-wrapper",
        field: field,
        fieldKey: fieldKey,
        id: id,
        tab: tab,
        children: this.renderFormField(field, fieldKey, options)
      }, fieldKey.join('.'));
      if (field.display_width === FIELD_DISPLAY_WIDTHS.HALF_WIDTH) {
        return /*#__PURE__*/_jsx(TwoColumnsFieldWrapper, {
          children: wrappedFormField
        }, fieldKey.join('.'));
      }
      return wrappedFormField;
    });
  }
  renderFieldKeyLabel(fieldKey) {
    return /*#__PURE__*/_jsx(FieldKeyLabel, Object.assign({}, this.props, {
      fieldKey: fieldKey,
      fields: this.fields
    }));
  }
  renderNoFieldsMessage() {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "sunny",
      illustrationProps: {
        width: 150
      },
      title: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('fields.emptyMessage.noFieldsTitle')
        })
      }),
      children: this.renderOtherTabLinks()
    });
  }
  renderOtherTabLinks() {
    const {
      tab: selectedTab,
      onTabChange
    } = this.props;
    const moduleTabs = this.getModuleTabs();
    const tabLinks = [];
    Object.keys(moduleTabs).forEach(_tab => {
      if (moduleTabs[_tab] && _tab !== selectedTab) {
        const tabLink = /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`fields.emptyMessage.tabNames.${_tab}`)
        });
        if (onTabChange) {
          const editorTabName = _tab === CONTENT ? EDIT : _tab.toLowerCase();
          tabLinks.push( /*#__PURE__*/_jsx(Link, {
            onClick: () => onTabChange(editorTabName),
            children: tabLink
          }, `tabLink-${tabLink}`));
        } else {
          tabLinks.push(tabLink);
        }
      }
    });
    if (!tabLinks.length) return null;
    return /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('fields.emptyMessage.noFieldsBody'),
        options: {
          tabLink: /*#__PURE__*/_jsx(FormattedList, {
            exclusive: true,
            children: tabLinks
          })
        }
      })
    });
  }
  renderInlineHelpTextAlert(inlineHelpText) {
    const {
      moduleSpec
    } = this.props;
    const {
      messages,
      masterLanguage
    } = moduleSpec;
    const currentUserLang = getLang();
    return this.renderAlert( /*#__PURE__*/_jsx(SanitizedLabel, {
      label: getTranslatedModuleInlineHelpText(inlineHelpText, masterLanguage, currentUserLang, messages),
      useStrict: true
    }));
  }
  renderHeader(selectedField) {
    const {
      hideBackLink,
      hideBreadcrumbs,
      hideHeader,
      HeaderLabelComponent,
      label
    } = this.props;
    const {
      fieldKey
    } = this.state;
    const {
      icon
    } = selectedField || {};
    return !hideHeader && /*#__PURE__*/_jsx(EditFormHeader, {
      fieldKey: fieldKey,
      fields: this.fields,
      flushOnTop: hideBackLink && hideBreadcrumbs,
      HeaderLabelComponent: HeaderLabelComponent,
      label: label,
      module: this.moduleData,
      icon: icon
    });
  }
  renderNavigation() {
    const {
      hideBackLink,
      hideBreadcrumbs,
      onFieldKeyChange,
      rootBreadcrumbs
    } = this.props;
    const {
      fieldKey
    } = this.state;
    if (!fieldKey || hideBreadcrumbs || hideBackLink) return null;
    return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
      fieldKey: fieldKey,
      fields: this.fields,
      onKeyChange: onFieldKeyChange,
      module: this.moduleData,
      rootBreadcrumbs: rootBreadcrumbs
    });
  }
  renderGlobalStylesLoader() {
    if (this.shouldLoadGlobalStyles) {
      return /*#__PURE__*/_jsx(StylesLoader, {});
    }
    return null;
  }
  renderBackLink() {
    const {
      hideBackLink,
      moduleSpec
    } = this.props;
    const {
      fieldKey
    } = this.state;
    if (hideBackLink || !fieldKey) return null;
    const backLinkKey = getBackLinkKey(fieldKey, this.fields);
    let label = moduleSpec.name || this.props.label;
    if (backLinkKey) label = this.renderFieldKeyLabel(backLinkKey);
    return /*#__PURE__*/_jsx(Breadcrumbs, {
      "data-selenium": "cmv2-edit-form-back-link",
      margin: "0",
      paddingInline: "600",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => this.setFieldKey(backLinkKey || null),
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('backLink.backToLabel'),
          options: {
            label
          }
        })
      })
    });
  }
  renderPrevNextOccurrenceButtons() {
    const {
      fieldKey
    } = this.state;
    const {
      moduleSpec
    } = this.props;
    return /*#__PURE__*/_jsx(OccurrencePrevNextButtons, {
      fieldKey: fieldKey,
      fields: this.fields,
      module: this.moduleData,
      moduleSpec: moduleSpec,
      onFieldChange: this.onFieldChange,
      setFieldKey: this.setFieldKey
    });
  }
  renderModuleFormAlert(filteredFields, tabGroup) {
    const {
      breakpoint,
      breakpointStyles,
      module,
      tab,
      hideEmptyMessage
    } = this.props;
    if (this.isLocked) {
      return this.renderAlert( /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('fields.emptyMessage.locked')
      }));
    }
    if (!filteredFields.length && !hideEmptyMessage) {
      return this.renderNoFieldsMessage();
    }
    if (tab !== CONTENT && tabGroup && isFieldDisabled({
      allFields: this.fields,
      breakpoint,
      breakpointStyles,
      field: tabGroup,
      module,
      scopes: this.scopes
    })) {
      const {
        disabled_controls
      } = tabGroup;
      return /*#__PURE__*/_jsx(Alert, {
        type: "tip",
        marginInline: "600",
        marginBlock: "300",
        children: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: disabled_controls.message,
          useStrict: true
        })
      });
    }
    return null;
  }
  renderInlineHelpText(filteredFields, selectedField) {
    const {
      moduleSpec
    } = this.props;
    const {
      inlineHelpText: moduleInlineHelpText
    } = moduleSpec;
    if (!selectedField && filteredFields.length && moduleInlineHelpText && !this.isLocked) {
      return this.renderInlineHelpTextAlert(moduleInlineHelpText);
    }
    return null;
  }
  renderChangeRecommendedSection() {
    const {
      ChangeRecommendedSection
    } = this.props;
    if (!ChangeRecommendedSection) {
      return null;
    }
    return /*#__PURE__*/_jsx(ChangeRecommendedSection, {});
  }
  renderContentAboveFields() {
    const {
      contentAboveFields,
      flush
    } = this.props;
    if (!contentAboveFields) {
      return null;
    }
    return flush ? contentAboveFields : /*#__PURE__*/_jsx(View, {
      marginInline: "600",
      children: contentAboveFields
    });
  }
  renderModuleForm(filteredFields, tabGroup) {
    const {
      fields,
      scopes
    } = this;
    const {
      fieldKey
    } = this.state;
    const {
      breakpoint,
      breakpointStyles,
      FieldWrapper: _FieldWrapper,
      id,
      module,
      tab
    } = this.props;
    const FieldWrapper = _FieldWrapper;
    const field = fieldKey && getFieldFromKey(fields, fieldKey);
    if (field) {
      return /*#__PURE__*/_jsx(FieldWrapper, {
        "data-test-id": "field-wrapper",
        field: field,
        fieldKey: fieldKey,
        id: id,
        children: this.renderFormField(field, fieldKey, {
          currentFieldId: field.id
        })
      }, fieldKey.join('.'));
    }
    if (this.isLocked || !filteredFields.length) return null;
    if (tab && tab !== CONTENT && tabGroup) {
      const parentFieldGroupDisabled = isFieldDisabled({
        allFields: fields,
        breakpoint,
        breakpointStyles,
        field: tabGroup,
        module,
        scopes
      });
      const fieldGroupKey = [tabGroup.name];
      const options = {
        currentFieldId: tabGroup.id,
        parentFieldGroupDisabled
      };
      this.topLevelNonContentFieldGroupKey = fieldGroupKey;
      return this.renderFormFields(filteredFields, fieldGroupKey, options);
    }
    return this.renderFormFields(filteredFields);
  }
  render() {
    const {
      fields
    } = this;
    const {
      tab
    } = this.props;
    const {
      shouldSlideInFromLeft,
      shouldSlideInFromRight,
      fieldKey
    } = this.state;
    const tabGroup = getFieldGroupForTab(this.fields, tab);
    const filteredFields = this.getFieldsForTab(tabGroup);
    const selectedField = fieldKey && getFieldFromKey(fields, fieldKey);
    return /*#__PURE__*/_jsx(DataTokenProvider, {
      TokenViewerComponent: this.props.TokenViewerComponent,
      children: /*#__PURE__*/_jsxs("div", {
        "data-test-id": this.props.dataTestId,
        children: [this.renderGlobalStylesLoader(), this.renderBackLink(), this.renderNavigation(), this.renderPrevNextOccurrenceButtons(), /*#__PURE__*/_jsxs(SlideInAnimationWrapper, {
          "data-animation-is-complete": !(shouldSlideInFromRight || shouldSlideInFromLeft),
          onAnimationEnd: this.onAnimationEnd,
          shouldSlideInFromLeft: shouldSlideInFromLeft,
          shouldSlideInFromRight: shouldSlideInFromRight,
          children: [this.renderHeader(selectedField), this.renderModuleFormAlert(filteredFields, tabGroup), this.renderInlineHelpText(filteredFields, selectedField), this.renderChangeRecommendedSection(), this.renderContentAboveFields(), /*#__PURE__*/_jsx("div", {
            children: this.renderModuleForm(filteredFields, tabGroup)
          })]
        })]
      }, this.props.id)
    });
  }
}
EditForm.defaultProps = {
  allowDataTokes: false,
  auth: {},
  className: '',
  dataTestId: 'module-edit-form',
  enableSlideInAnimation: false,
  fieldKey: null,
  flush: true,
  hideBackLink: false,
  hideBreadcrumbs: true,
  hideLockedFields: true,
  overrideable: true,
  pageContext: {},
  readOnly: false,
  tab: CONTENT,
  validateOnMount: false,
  allowFieldReset: false,
  hideEmptyMessage: false,
  FieldWrapper: DefaultFieldWrapper
};
export default withTheme(connector(EditForm));